// sendMailToFallback.js
'use strict';
import submitEmailToSupport from '../action/submitEmailToSupport.js';
import sendCurrentRemoteConfig from '../action/sendCurrentRemoteConfig.js';

/**
 * Send mail to fallback when customer service is not available
 * @kind action
 * @return {Promise} Action promise.
 */
const sendMailToFallback = () => async dispatch => {
  await dispatch(submitEmailToSupport());
  await dispatch(sendCurrentRemoteConfig());
};

export default sendMailToFallback;
